import { urls } from '@/constants/urls';
import { useCurrentOrganisation } from '@/hooks/use-current-organisation';

export const useGroupsUrl = () => {
  const { isUsingOrganisationOverride, organisation } =
    useCurrentOrganisation();
  return isUsingOrganisationOverride
    ? urls.organisations.organisation.groups.base.compose(
        organisation?.id as number,
      )
    : urls.groups.base;
};
